/** Customer dashboard / My Bookings tab — matches backend when registration is active + paid. */

import { bookingPackageEndDate } from './bookingPackageDates.js';

export function bookingPaidTotal(booking) {
  return Number(booking?.amountPaidAtOffice ?? 0) + Number(booking?.amountPaidOnline ?? 0);
}

function registrationStatus(booking) {
  return String(booking?.registration?.status || '').trim().toLowerCase();
}

export function isRegistrationActiveForCustomer(booking) {
  const regStatus = registrationStatus(booking);
  if (!regStatus || regStatus === 'cancelled' || regStatus === 'rejected' || regStatus === 'rusticated') {
    return false;
  }
  if (regStatus === 'confirmed' || regStatus === 'advanced_paid') return true;

  const bookingStatus = String(booking?.status || '').trim().toLowerCase();
  if (
    bookingStatus === 'confirmed' ||
    bookingStatus === 'fully_paid' ||
    bookingStatus === 'advance_paid' ||
    bookingStatus === 'remaining_pending'
  ) {
    return true;
  }

  const paid = bookingPaidTotal(booking);
  if (paid <= 0.02) return false;
  return paid > 0.02;
}

export function isBatchEndBeforeToday(endDate) {
  if (!endDate) return false;
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return false;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  return endDay < today;
}

export function resolveCustomerBookingTab(booking) {
  const packageEnd = bookingPackageEndDate(booking);
  if (isRegistrationActiveForCustomer(booking)) {
    return isBatchEndBeforeToday(packageEnd) ? 'completed' : 'upcoming';
  }

  const bookingStatus = String(booking?.status || '').trim().toLowerCase();
  if (bookingStatus === 'cancelled') return 'cancelled';

  const regStatus = registrationStatus(booking);
  if (regStatus === 'cancelled') return 'cancelled';

  const cancelStatus = String(booking?.cancellationRequestStatus || '').trim().toLowerCase();
  if (cancelStatus === 'cancelled' || cancelStatus === 'refunded') return 'cancelled';

  if (isBatchEndBeforeToday(packageEnd)) return 'completed';
  return 'upcoming';
}
